import { Permission, userHasAnyPermission, userHasPermission } from "~/domains/user/utils/permissions";
import { getProductData, isKITProduct, type ProductData } from "~/domains/product/types/ProductData";
import { isProductPMA } from "~/domains/product/utils/productDescriptorUtils";
import { userIsCustomer, userIsLoggedIn } from "~/domains/user/utils/roles";
import { hasSuccessor } from "~/utils/productUtils";
import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";

interface CanSeeListPriceProps {
  product: ProductDescriptor;
  hasSurcharge?: boolean;
  isSpecialPrice?: boolean;
}

export function canSeeListPrice({ product, isSpecialPrice, hasSurcharge }: CanSeeListPriceProps) {
  return (
    userHasPermission(Permission.SEE_LIST_PRICE) &&
    product.base.quantityVisible &&
    !isKITProduct(product.base) &&
    !isProductPMA(product) &&
    !isSpecialPrice &&
    !hasSurcharge
  );
}

export function canSeeWishlistButton() {
  return !userIsLoggedIn() || userHasPermission(Permission.ADD_TO_WISHLIST);
}

export function canSeeAddToCartButton(strict = false) {
  if (userIsCustomer()) {
    return strict
      ? userHasPermission(Permission.ADD_TO_CART)
      : userHasAnyPermission(Permission.ADD_TO_CART, Permission.ADD_TO_QUOTE);
  } else if (userHasPermission(Permission.ADD_TO_CART)) {
    return true;
  }
}

export function canSeeNewProductVersion(product: ProductData | ProductDescriptor) {
  return userIsLoggedIn() && hasSuccessor(getProductData(product));
}
